export class Education {
  comments: string;
  currentlyAttending: boolean;
  degree: string;
  endDate: Date;
  id: number;
  institutionName: string;
  major: string;
  startDate: Date;
  subInstitutionName: string;
  index: number;
}
